import { makeStyles } from '@material-ui/core';
import { rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../../../mui-theme';

export const styles = makeStyles(theme => ({
  contentArea: {
    display: 'flex',
  },
  actionTitle: {
    fontSize: rem(2),
    fontWeight: 500,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    marginTop: vh(6.5),
    color: themeColor.modalTitle,
  },
  confirmMessage: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: rem(1.125),
    marginBottom: '7vh',
    color: theme.palette.info.dark,
    marginTop: vh(1.3),
    textAlign: 'center',
    width: vw(50),
  },
  middleContainer: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  bottomContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flexGrow: 10,
    paddingBottom: '22vw',
    backgroundColor: themeColor.modalBackground,
    '@media (width: 1366px) and (height: 768px)': {
      paddingBottom: '21vw',
    },
  },
  inputTextArea: {
    marginTop: vh(2.5),
    fontSize: rem(1.125),
    color: themeColor.defaultTextColor,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    outline: 'none',
    height: '22%',
    width: vw(33),
  },
  textContainer: {
    width: 'fit-content',
    display: 'flex',
    alignItems: 'flex-start',
    margin: 'auto',
  },
  subBarText: {
    paddingLeft: vw(0.7320644217),
    paddingTop: vh(0.6510416667),
    color: themeColor.defaultTextColor,
  },
  charContainer: {
    display: 'flex',
    color: theme.palette.info.dark,
    fontSize: vh(1.859),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    marginLeft: '0.5vw',
  },
  charCount: {
    paddingTop: '0.29vh',
    color: theme.palette.info.dark,
    fontSize: vh(1.859),
    paddingRight: '0.6vh',
    fontWeight: 500,
  },
  charTotal: {
    color: theme.palette.info.dark,
    fontSize: vh(1.859),
    paddingTop: '0.23vh',
  },
  buttonContainer: {
    marginRight: '2.0497803807vw',
    height: '10vh',
    '@media (aspect-ratio: 4/3)': {
      height: '18vh',
    },
    '@media (aspect-ratio: 16/9)': {
      height: '9vh',
    },
  },
}));
